import { Component } from '@angular/core';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';

@Component({
    selector: 'app-view-category',
    templateUrl: './view-category.component.html',
    styleUrl: './view-category.component.css',
    standalone: false
})
export class ViewCategoryComponent {
  showCategory:boolean = true;
  model: any = {
    imageUrl : "assets/milk/milk1.jpg",
    status : true,
    type : 'sub'
  };
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  categoryList:any = [];
  subCategoryList:any = [];
  uploadImages:any = []

  dropdownSettings:any = {};

  constructor(private apiService:ApiServiceListService) { }

  ngOnInit() {
    this.getCategoryList();
    this.breadcrumb = {
      'mainlabel': 'Category Management',
      // 'links': [
      //   {
      //     'name': 'Home',
      //     'isLink': false,
      //     'link': '/dashboard/sales'
      //   },
      //   {
      //     'name': 'ChangeLog',
      //     'isLink': false,
      //     'link': '#'
      //   },
      // ]
    };
    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection:true
    };
  }

  imageUpload(ev:any) {
    console.log(ev.target.files);
    
    if (ev.target.files.length >0 ) {
      for (let index = 0; index < ev.target.files.length; index++) {
        const element = ev.target.files[index];
        let file = element;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e :any) => {
          
         let url =  e.target.result;
         this.uploadImages.push(url);
         console.log(this.uploadImages);

        }
      }
    } else {

    } 
  }

  getCategoryList() {
    let parameter:any = {
      methodType : "GET",
    }
    // this.apiService.getCategoryList(parameter).subscribe((response:any) => {
    //   this.categoryList = response.data;
    // }, (error) => {

    // });
  }

  cateTypeSelect() {    
    if (this.model.type == 'sub') {
      this.showCategory = true;
    } else {
      this.showCategory =  false
    }
  }
  addCategory(valid) {
    console.log(this.model);

      if (valid) {
        let parameter:any = {
          methodType : "POST",
        }
        let body:any = {};
        body = this.model;
        body.mainCategory = this.model.category[0]._id;
       if (this.model.status) {
          body.status = 'Active'
       } else {
        body.status = 'InActive'
       }
      
        this.apiService.addCategoryAPI(parameter, body).subscribe((response:any) => {
          console.log(response);
          
        }, (error) => {
    
        });
      }
    
  }

}
